// extracted by mini-css-extract-plugin
var _1 = "#68914d";
var _2 = "#9cc681";
var _3 = "#8ab46f";
var _4 = "8px";
var _5 = "6px";
var _6 = "8px";
var _7 = "0 1px 1px 0 rgba(0,0,0,.02) inset";
var _8 = "0 8px 8px -4px rgba(0,0,0,.03),0 16px 24px -4px rgba(0,0,0,.08)";
var _9 = "10px";
var _a = "#e8e8e8";
var _b = "16px 24px";
var _c = "#38aa73";
var _d = "#956c22";
var _e = "#2988bd";
var _f = "#eee";
var _10 = "#c4842d";
var _11 = "#b8567c";
var _12 = "#8b6e4e";
var _13 = "#5889c2";
var _14 = "#4e8a8a";
var _15 = "#6a8a3e";
var _16 = "#7b5ea7";
var _17 = "#4a6fa5";
var _18 = "#3a8a6e";
var _19 = "#c25b4e";
var _1a = "#fafbfc";
var _1b = "#1e3050";
var _1c = "#293d62";
var _1d = "#fafbfc";
var _1e = "rgba(0,0,0,.12)";
var _1f = "#d9d9d9";
var _20 = "rgba(5,5,5,.1)";
var _21 = "#eaf2fc";
var _22 = "rgba(0,0,0,.65)";
var _23 = "#ebebeb";
var _24 = "#068467";
var _25 = "rgba(6,132,103,.1)";
var _26 = "#dc4949";
var _27 = "rgba(220,73,73,.1)";
var _28 = "#787c81";
var _29 = "#d6d9dc";
var _2a = "#f3f5f7";
var _2b = "#73c9b2";
var _2c = "linear-gradient(180deg, #73C9B2 0%, #B8E7DA 100%)";
var _2d = "#b8e7da";
var _2e = "#5357f8";
var _2f = "rgb(14.3921787709,19.9877094972,245.2078212291)";
var _30 = "rgb(249.6189944134,249.7441340782,254.7810055866)";
var _31 = "#f7f8f9";
var _32 = "#edeeef";
var _33 = "#7b8996";
var _34 = "#ededed";
var _35 = "#f4f5f7";
var _36 = "#fbfbfc";
var _37 = "rgba(0,0,0,.75)";
var _38 = "rgba(171.2567039106,172.4612273574,220.9432960894,.95)";
var _39 = "rgba(0,0,0,.3)";
var _3a = "rgba(0,0,0,.5)";
var _3b = "rgba(0,0,0,.4)";
var _3c = "rgba(0,0,0,.95)";
var _3d = "rgba(0,0,0,.65)";
var _3e = "rgba(0,0,0,.85)";
var _3f = "content___MEAUt";
var _40 = "20px";
var _41 = "#f41e28";
var _42 = "1063px";
var _43 = "edit-button___wePPA";
var _44 = "edit-button-divider___d52Yo";
var _45 = "rgba(227,89,86,.2)";
var _46 = "#e35956";
var _47 = "filter-box___IoWEF";
var _48 = "filter-box-divider___UVpcV";
var _49 = "filter-fade___nT8og";
var _4a = "filter-item___J9VUg";
var _4b = "16px 24px";
var _4c = "28px";
var _4d = "32px";
var _4e = "18px";
var _4f = "14px";
var _50 = "14px";
var _51 = "15px";
var _52 = "12.6px";
var _53 = "11px";
var _54 = "20px";
var _55 = "28px";
var _56 = "700";
var _57 = "200";
var _58 = "300";
var _59 = "500";
var _5a = "400";
var _5b = "600";
var _5c = "hsla(0,0%,100%,.2)";
var _5d = "#ccc";
var _5e = "49px";
var _5f = "hint-container___vrAKm";
var _60 = "5px";
var _61 = "info-icon___WT5f_";
var _62 = "info-row___lI1aK";
var _63 = "item-box___jMV6W";
var _64 = "left-fade___VXK06";
var _65 = "left-scroll-arrow___EtXtY";
var _66 = "#5357f8";
var _67 = "rgba(0,0,0,.4)";
var _68 = "popover-text___HlfIM";
var _69 = "#fafafa";
var _6a = "hsla(0,0%,100%,.9)";
var _6b = "prefix___eQiz_";
var _6c = "right-fade___yvJKi";
var _6d = "right-scroll-arrow___FfMb9";
var _6e = "15px";
var _6f = "20px";
var _70 = "24px";
var _71 = "scroll-arrow___FeLZF";
var _72 = "scrollable-container___FTbEW";
var _73 = "shaded___EZsQz";
var _74 = "hsla(0,0%,100%,.6)";
var _75 = "#7e7eff";
var _76 = "hsla(0,0%,100%,.7)";
var _77 = "hsla(0,0%,100%,.3)";
var _78 = "hsla(0,0%,100%,.575)";
var _79 = "60px";
var _7a = "208px";
var _7b = "strikethrough___NbTvV";
var _7c = "rgba(82,196,26,.2)";
var _7d = "#52c41a";
var _7e = "12px";
var _7f = "20px";
var _80 = "title___RSG4Q";
var _81 = "rgba(250,173,20,.2)";
var _82 = "#faad14";
var _83 = "#fff";
var _84 = "hsla(0,0%,100%,.2)";
export { _1 as "actionButtonColorDark", _2 as "actionButtonColorLight", _3 as "actionButtonColorMedium", _4 as "borderRadiusCard", _5 as "borderRadiusMain", _6 as "borderRadiusSurface", _7 as "boxShadowInnerXs", _8 as "boxShadowXl", _9 as "btnRightMargin", _a as "cardBorderColor", _b as "cardPadding", _c as "changeSetCompletedColor", _d as "changeSetManuallyChangesProposed", _e as "changeSetScheduledChangesProposed", _f as "chipBackground", _10 as "colorAccentAmber", _11 as "colorAccentBerry", _12 as "colorAccentBrown", _13 as "colorAccentCornflower", _14 as "colorAccentCyan", _15 as "colorAccentOlive", _16 as "colorAccentPurple", _17 as "colorAccentSteelBlue", _18 as "colorAccentTeal", _19 as "colorAccentTerracotta", _1a as "colorBackgroundMain", _1b as "colorBackgroundSidebar", _1c as "colorBackgroundSidebarHover", _1d as "colorBackgroundTabs", _1e as "colorBorderContainer", _1f as "colorBorderMain", _20 as "colorBorderSecondary", _21 as "colorDeltaCyanBlueBg", _22 as "colorDeltaGray", _23 as "colorDeltaGrayBg", _24 as "colorDeltaGreen", _25 as "colorDeltaGreenBg", _26 as "colorDeltaRed", _27 as "colorDeltaRedBg", _28 as "colorDetailsFieldText", _29 as "colorDetailsIcon", _2a as "colorDetailsTagBg", _2b as "colorMint", _2c as "colorMintGradient", _2d as "colorMintLight", _2e as "colorPrimary", _2f as "colorPrimaryHover", _30 as "colorPrimaryLightened", _31 as "colorTableHeadBg", _32 as "colorTableHeadBgHover", _33 as "colorTableHeadSubtitle", _34 as "colorTableRowBorder", _35 as "colorTableTextBg", _36 as "colorTableTotalRowBg", _37 as "colorTextBase", _38 as "colorTextDisabled", _39 as "colorTextExtraLight", _3a as "colorTextLight", _3b as "colorTextLighter", _3c as "colorTextMainHeading", _3d as "colorTextMuted", _3e as "colorTextPrimary", _3f as "content", _40 as "contentHorizPadding", _41 as "dangerColor", _42 as "dashboardPdfContentWidth", _43 as "edit-button", _44 as "edit-button-divider", _45 as "errorBackcolor", _46 as "errorColor", _47 as "filter-box", _48 as "filter-box-divider", _49 as "filter-fade", _4a as "filter-item", _4b as "filterPanelPadding", _4c as "filtersDefaultHeight", _4d as "filtersTallHeight", _4e as "fontSizeLarge", _4f as "fontSizeMain", _50 as "fontSizeMedium", _51 as "fontSizePlus", _52 as "fontSizeSmaller", _53 as "fontSizeSmallest", _54 as "fontSizeXLarge", _55 as "fontSizeXxLarge", _56 as "fontWeightBold", _57 as "fontWeightExtraLight", _58 as "fontWeightLight", _59 as "fontWeightMediumBold", _5a as "fontWeightNormal", _5b as "fontWeightSemiBold", _5c as "ghostWhite", _5d as "grayBackgroundColor", _5e as "headerHeight", _5f as "hint-container", _60 as "iconHorizontalMargin", _61 as "info-icon", _62 as "info-row", _63 as "item-box", _64 as "left-fade", _65 as "left-scroll-arrow", _66 as "linkColor", _67 as "linkColorMuted", _68 as "popover-text", _69 as "popoverHeaderColor", _6a as "popoverMaskColor", _6b as "prefix", _6c as "right-fade", _6d as "right-scroll-arrow", _6e as "rowPadding", _6f as "ruleInnerGutters", _70 as "ruleSideGutters", _71 as "scroll-arrow", _72 as "scrollable-container", _73 as "shaded", _74 as "sideMenuIconColor", _75 as "sideMenuIconSelectedColor", _76 as "sideMenuItemColor", _77 as "sideMenuScrollbarThumbColor", _78 as "sideMenuSubmenuItemColor", _79 as "sidebarCollapsedWidth", _7a as "sidebarWidth", _7b as "strikethrough", _7c as "successBackcolor", _7d as "successColor", _7e as "tableHeaderVerticalPadding", _7f as "tableHorizPadding", _80 as "title", _81 as "warningBackcolor", _82 as "warningColor", _83 as "whiteColor", _84 as "whiteDividerColor" }
